/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { linkOption } from 'src/core/components/InfoCardWithExternalLink';
import { CustomSkillProjectKind } from 'src/core/stores/app/types';
import {
    classificationSdkLink,
    cluCsharpGithubSampleLink,
    cluPythonGithubSampleLink,
    cluSdkLink,
    extractionCsharpGithubSampleLink,
    extractionJavaGithubSampleLink,
    extractionJavaScriptGithubSampleLink,
    extractionPythonGithubSampleLink,
    extractionSdkLink,
    multiClassificationCsharpGithubSampleLink,
    multiClassificationJavaGithubSampleLink,
    multiClassificationJavaScriptGithubSampleLink,
    multiClassificationPythonGithubSampleLink,
    orchestrationSdkLink,
    singleClassificationCsharpGithubSampleLink,
    singleClassificationJavaGithubSampleLink,
    singleClassificationJavaScriptGithubSampleLink,
    singleClassificationPythonGithubSampleLink
} from 'src/modules/modelDeploy/utils/runtimeCardsLinks';

export const getSdkLink = (projectKind: CustomSkillProjectKind) => {
    switch (projectKind) {
        case 'Conversation':
            return cluSdkLink;
        case 'Orchestration':
            return orchestrationSdkLink;
        case 'CustomSingleLabelClassification':
        case 'CustomMultiLabelClassification':
            return classificationSdkLink;
        case 'CustomEntityRecognition':
            return extractionSdkLink;
        default:
    }
};

export const getGithubSamples = (projectKind: CustomSkillProjectKind, baseLinkText: string): linkOption[] => {
    switch (projectKind) {
        case 'CustomEntityRecognition':
            return [
                { key: 'cSharpGithubSample', text: `${baseLinkText} - C#`, href: extractionCsharpGithubSampleLink },
                { key: 'pythonGithubSample', text: `${baseLinkText} - Python`, href: extractionPythonGithubSampleLink },
                { key: 'javaGithubSample', text: `${baseLinkText} - Java`, href: extractionJavaGithubSampleLink },
                { key: 'jsGithubSample', text: `${baseLinkText} - JavaScript`, href: extractionJavaScriptGithubSampleLink }
            ];
        case 'CustomSingleLabelClassification':
            return [
                { key: 'cSharpGithubSample', text: `${baseLinkText} - C#`, href: singleClassificationCsharpGithubSampleLink },
                { key: 'pythonGithubSample', text: `${baseLinkText} - Python`, href: singleClassificationPythonGithubSampleLink },
                { key: 'javaGithubSample', text: `${baseLinkText} - Java`, href: singleClassificationJavaGithubSampleLink },
                { key: 'jsGithubSample', text: `${baseLinkText} - JavaScript`, href: singleClassificationJavaScriptGithubSampleLink }
            ];
        case 'CustomMultiLabelClassification':
            return [
                { key: 'cSharpGithubSample', text: `${baseLinkText} - C#`, href: multiClassificationCsharpGithubSampleLink },
                { key: 'pythonGithubSample', text: `${baseLinkText} - Python`, href: multiClassificationPythonGithubSampleLink },
                { key: 'javaGithubSample', text: `${baseLinkText} - Java`, href: multiClassificationJavaGithubSampleLink },
                { key: 'jsGithubSample', text: `${baseLinkText} - JavaScript`, href: multiClassificationJavaScriptGithubSampleLink }
            ];
        case 'Conversation':
        case 'Orchestration':
            return [
                { key: 'cSharpGithubSample', text: `${baseLinkText} - C#`, href: cluCsharpGithubSampleLink },
                { key: 'pythonGithubSample', text: `${baseLinkText} - Python`, href: cluPythonGithubSampleLink }
            ];
        default:
    }
};
